import React from 'react';

import {ButtonShowSignoffActivitiesModal} from './SignoffActivitiesModal';
import {SignoffStatus} from './SignoffStatus';

import {
  SignoffDocumentSerializedType,
  SignoffSerializedType,
} from 'sweet-types';

interface Props {
  signoff: SignoffSerializedType | SignoffDocumentSerializedType;
  alignment: 'left' | 'right';
  hidePreviousVersionBadge?: boolean;
}

export function SignoffStatusWithButton({
  signoff,
  alignment,
  hidePreviousVersionBadge,
}: Props): JSX.Element {
  const content = (
    <SignoffStatus
      key="content"
      signoff={signoff}
      alignment={alignment}
      previousVersionStyle={hidePreviousVersionBadge ? 'hidden' : 'badge'}
    />
  );

  const button = (
    <ButtonShowSignoffActivitiesModal signoff={signoff} key="button" />
  );

  return (
    <span className="font-italic">
      {alignment === 'left' ? [content, ' ', button] : [button, ' ', content]}
    </span>
  );
}
